import * as React from "react";
import { PromptGeneratorContext } from "./context";
import { type PromptGeneratorContextState } from "@/components/feature/promptGenerator/types";

interface Props {
  children: React.ReactNode;
}

export const PromptGeneratorContextProvider: React.FC<Props> = ({ children }) => {
  const [state, setState] = React.useState<PromptGeneratorContextState>({
    promptToImprove: null,
    promptToChat: null,
    isSendingToChat: false,
    sentChatMessageIds: new Set(),
  });

  return <PromptGeneratorContext.Provider value={{ state, setState }}>{children}</PromptGeneratorContext.Provider>;
};
